"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgCalendarFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M6 4h1V3c-.002-.667.33-1 1-1 .67 0 1.004.333 1.004 1v1H15V2.941c0-.627.333-.941 1-.941s1 .314 1 .941V4h1c1.333 0 2 .667 2 2v14c0 1.333-.667 2-2 2H6c-1.333 0-2-.667-2-2V6.004C4 4.668 4.667 4 6 4zM4 8v2h16V8H4zm5 7h1c.667 0 1-.333 1-1s-.333-1-1-1h-.998c-.667-.001-1.001.332-1.002 1 0 .668.333 1.001 1 1zm5 0h1c.667 0 1-.333 1-1s-.333-1-1-1h-.998c-.667-.001-1.001.332-1.002 1 0 .668.333 1.001 1 1zm-5 4h1c.667 0 1-.333 1-1s-.333-1-1-1h-.998c-.667-.001-1.001.332-1.002 1 0 .668.333 1.001 1 1zm5 0h1c.667 0 1-.333 1-1s-.333-1-1-1h-.998c-.667-.001-1.001.332-1.002 1 0 .668.333 1.001 1 1z' }))); };
exports.default = SvgCalendarFilled;
//# sourceMappingURL=CalendarFilled.js.map